module.exports = "/assets/packs/images/9d73b18bc69bddf7ad3cce78b2b99e42.png";